var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.resource)?_c('div',{staticClass:"background"},[_c('BaseResourceImage',{staticClass:"image",style:(`filter: ${_vm.isGreyscaled ? 'grayscale(100%)' : ''} ${_vm.isBlurred ? 'blur(9px)' : ''};`),attrs:{"resource":_vm.resource,"type":_vm.type,"should-lazyload":false,"is-background":true,"fill":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }